module.exports = __webpack_public_path__ + "static/media/wifi.ad9383dd.svg";